import { apiGetInvoices } from "@lib/api/billing";
import { createYupSync } from "@lib/helpers/TableHelper";
import { noteSchema as yupSchema } from "@lib/schemas/note";
import { Invoice } from "@lib/types/Billing";
import { Note } from "@lib/types/Note";
import { useQuery } from "@tanstack/react-query";
import { Form, FormInstance, Input, Select, Typography } from "antd";
import { useEffect } from "react";
import { useIntl } from "react-intl";

type Props<T> = {
  form: FormInstance<T>;
  loading: boolean;
  note?: T;
  invoice?: Invoice;
};

export default function NoteInvoiceInput<T extends Note>(props: Props<T>) {
  const { loading, note, invoice, form } = props;
  const { messages } = useIntl();

  const isNotEditable = note || invoice;

  const { data, isLoading } = useQuery({
    queryFn: () =>
      apiGetInvoices({
        page: 1,
        limit: 100,
        sort: "createdAt,DESC",
        join: ["customer", "orders"],
      }),
    queryKey: ["invoices-dropdown"],
    enabled: !isNotEditable && !loading,
  });

  useEffect(() => {
    if (!form) return;
    if (isNotEditable) {
      form?.setFieldsValue({
        invoiceId: (note?.invoice?.id || invoice?.id) as any,
      });
    }
  }, [isNotEditable]);

  if (note && !note?.invoice) return null;

  return (
    <Form.Item
      name="invoiceId"
      rules={[createYupSync({ schema: yupSchema })]}
      label={messages["common.invoice"] as string}
    >
      {isNotEditable && (
        <>
          <Typography>{note?.invoice?.id || invoice?.id || ""}</Typography>
          <Input
            type="text"
            value={note?.invoice?.id || invoice?.id || ""}
            style={{ display: "none" }}
          />
        </>
      )}

      {!isNotEditable && (
        <Select
          placeholder={messages["common.makeYourChoice"] as string}
          disabled={loading || isLoading}
          showSearch
          optionFilterProp="text"
          options={data?.data?.data?.map((item) => ({
            label: item.id,
            text: item.id,
            value: item.id,
          }))}
        />
      )}
    </Form.Item>
  );
}
